"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/Toggle/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _chat = require('shared/enum/chat');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');

var _Add = require('web/components/Add'); var _Add2 = _interopRequireDefault(_Add);





// "+" opens New chat; a video call starts from its Video call row.
const CreateNewToggle = ({ onCreateNewChat }) => {
  const hasAnyActiveOrgs = _hooks.useAppSelector.call(void 0, _user.selectHasAnyActiveOrgs)
  const openNewChat = _react.useCallback.call(void 0, () => onCreateNewChat(_chat.CHAT_TYPE.REGULAR), [onCreateNewChat])

  return (
    _react2.default.createElement(_Add2.default, {
      disabled: !hasAnyActiveOrgs,
      onClick: openNewChat,
      'aria-haspopup': "dialog", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
    )
  )
}

exports. default = _react.memo.call(void 0, CreateNewToggle)
